<template>
  <div class="page-container">
    <div class="account-card">
      <span class="parent-path">藥洗紀錄 / </span><span class="current-path">編輯藥洗內容</span>
      <span class="page-title">藥洗紀錄內容</span>
      <div class="card-content">
        <div class="header">
          <div class="user-info">
          </div>
          <div class="buttons">
            <a-button @click="onDelete" ghost danger>刪除</a-button>
            <a-button @click="onEdit" type="primary" ghost>編輯</a-button>
          </div>
        </div>
        <a-divider style="margin: 0"/>
        <div class="details">
          <span class="title">執行資訊</span>
          <div class="detail-row">
            <div>日期：<span>{{ date }}</span></div>
            <div>時間：<span>{{ time }}</span></div>
          </div>
          <div class="detail-row">
            <div>執行人員：<span>{{ cleaningLog.user?.last_name }}{{ cleaningLog.user?.first_name }}</span></div>
            <div>備註：<span>{{ cleaningLog.note }}</span></div>
          </div>
        </div>
        <a-divider style="margin: 0 20px; width: auto; min-width: auto"/>
        <div class="details">
          <span class="title">設備資訊</span>
          <div class="detail-row">
            <div>設備：<span>{{ cleaningLog.device_name }}</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {message, Modal} from "ant-design-vue";
import dayjs from "dayjs";

export default {
  name: 'AccountCard',
  inject: ['getUserData', 'clearUserData'],
  data() {
    return {
      cleaningLog: {}
    };
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    date() {
      return dayjs(this.cleaningLog.time).format('YYYY-MM-DD');
    },
    time() {
      return dayjs(this.cleaningLog.time).format('HH:mm');
    }
  },
  methods: {
    fetchData() {

      const token = localStorage.getItem('token');
      this.$axios.get(`/api/cleaning-logs/${this.$route.params.id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(response => {
        this.cleaningLog = response.data.data;
        console.log(response.data.data);
      }).catch(error => {
        console.error(error);
      });
    },
    onDelete() {

      Modal.confirm({
        title: '刪除藥洗記錄',
        content: '確認刪除此筆藥洗記錄嗎？',
        okText: '刪除',
        okType: 'primary',
        okButtonProps: {
          danger: true
        },
        cancelText: '取消',
        onOk: () => {

          const token = localStorage.getItem('token');
          this.$axios.delete(`/api/cleaning-logs/${this.$route.params.id}`, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }).then(response => {
            console.log(response.data.data);
            message.success('已將藥洗記錄刪除');
            this.$router.go(-1)

          }).catch(error => {
            console.error(error.status);
            if (error.status === 401) {
              this.$router.push('/login');
            }
          });
        },
      });
    },
    onEdit() {
      this.$router.push(`/cleaning-log/edit/${this.$route.params.id}`);
    },
  }
};
</script>

<style scoped>
.card-content {
  background-color: white;
  border-radius: 8px;
  margin-top: 16px;
  max-width: 800px;
}

.header {
  display: flex;
  justify-content: space-between;
  padding: 28px 32px;
}

hr {
  border: 1px solid #e0e0e0;
}

.user-info h3 {
  font-size: 24px;
  margin: 0;
}

.title {
  font-size: 20px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 10px;
  grid-column: 1 / 3;
}

.user-info p {
  color: gray;
  margin: 0;
}

.buttons button {
  margin-left: 10px;
}

.details {
  padding: 28px 32px;
}

.details {
  display: grid;
  grid-template-columns: repeat(2, auto);
  gap: 8px 16px;
}

.detail-row {
  display: contents;
}

.detail-row div {
  text-align: left;
  color: #999999;
  size: 18px;
}

.detail-row div span {
  color: #333333;
}
</style>
